import axios from 'axios'

import { ensureCsrfToken } from '../../../../lib/csrf'

const INVESTMENT_PROGRAMS_URL = '/api/digital-risk/investment-programs/'

const programUrl = ({ programReference }) => `${INVESTMENT_PROGRAMS_URL}${encodeURIComponent(programReference)}/`

const mutationConfig = async () => ({
    withCredentials: true,
    headers: { 'X-CSRFToken': await ensureCsrfToken() }
})

export const createInvestmentProgram = async (payload) => {
    const { data } = await axios.post(INVESTMENT_PROGRAMS_URL, payload, await mutationConfig())
    return data
}

export const createInvestmentProgramFromBoardDecision = async ({ boardDecisionReference }) => {
    const { data } = await axios.post(
        `${INVESTMENT_PROGRAMS_URL}from-board-decision/`,
        { board_decision_reference: boardDecisionReference },
        await mutationConfig()
    )
    return data
}

export const fetchInvestmentProgram = async ({ programReference }) => {
    const { data } = await axios.get(programUrl({ programReference }), { withCredentials: true })
    return data
}

export const fetchProjectAdoptionCandidates = async ({ programReference }) => {
    const { data } = await axios.get(`${programUrl({ programReference })}project-adoptions/`, { withCredentials: true })
    return data
}

export const adoptProposalProject = async ({ programReference, frozenProjectReference, managementExecutionAllocation }) => {
    const { data } = await axios.post(`${programUrl({ programReference })}project-adoptions/`, {
        frozen_project_reference: frozenProjectReference,
        management_execution_allocation: managementExecutionAllocation,
    }, await mutationConfig())
    return data
}

export const fetchProgramAuthorizationHistory = async ({ programReference }) => {
    const { data } = await axios.get(`${programUrl({ programReference })}authorization-history/`, { withCredentials: true })
    return data
}

export const fetchInvestmentPrograms = async () => {
    const { data } = await axios.get(INVESTMENT_PROGRAMS_URL, { withCredentials: true })
    return data
}

export const updateInvestmentProgram = async ({ programReference, payload }) => {
    const { data } = await axios.patch(programUrl({ programReference }), payload, await mutationConfig())
    return data
}

const projectUrl = ({ programReference, projectReference }) => `${programUrl({ programReference })}projects/${encodeURIComponent(projectReference)}/`

export const activateProgramProject = async ({ programReference, projectReference }) => {
    const { data } = await axios.post(`${projectUrl({ programReference, projectReference })}activate/`, {}, await mutationConfig())
    return data
}

export const updateProgramProject = async ({ programReference, projectReference, payload }) => {
    const { data } = await axios.patch(projectUrl({ programReference, projectReference }), payload, await mutationConfig())
    return data
}

export const releaseProgramCapital = async ({ programReference, projectReference, amount, reason, expectedOutstandingCommitment, expectedAuthorizationReference, idempotencyKey }) => {
    const config = await mutationConfig()
    config.headers['Idempotency-Key'] = idempotencyKey
    const { data } = await axios.post(`${projectUrl({ programReference, projectReference })}capital-releases/`, {
        amount,
        reason,
        expected_outstanding_commitment: expectedOutstandingCommitment,
        expected_authorization_reference: expectedAuthorizationReference,
    }, config)
    return data
}

export const fetchProgramCapitalReleaseHistory = async ({ programReference, projectReference }) => {
    const { data } = await axios.get(`${projectUrl({ programReference, projectReference })}capital-releases/`, { withCredentials: true })
    return data
}
